import React, { Component } from 'react';
import './feedbackButton.css';
import FeedbackPopup from "./FeedbackPopup";
import DarkOverlay from './DarkOverlay';

class FeedbackButton extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }

    render() {
        return (
            <div>
                <FeedbackPopup></FeedbackPopup>
                <div className="buttonOuter" title="Feedback" onClick={this.openPopup}>
                    <i className="bi bi-chat-left-text"></i>
                </div>
                <DarkOverlay></DarkOverlay>
            </div>
        );
    }
}

export default FeedbackButton;